/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import propTypes from 'prop-types';
import styled, { css } from 'styled-components';
// import classes from './DrawerToggle.module.css';
import { Menu } from '../../../editJournal/toolset/assets/icons';
import { translucentGray } from '../../../../../../styling/theme';

const DrawerWapper = styled.div`
  grid-column: 8 / span 1;
  grid-row: 1 / span 1;
  margin: 0 24px 0 0;
  display: none;
  justify-self: end;

  ${(props) => {
    const { drive } = props;
    if (drive) {
      return css`
        grid-column: 8 / span 1;
        grid-row: 1 / span 1;
        justify-self: end;
      `;
    }
    return css``;
  }}

  @media (max-width: 767px) {
    display: flex;
    grid-column: 4 / span 1;
    grid-row: 1 / span 1;
    margin-right: 0;
    justify-self: end;
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    &:hover {
      background: ${translucentGray};
    }
  }

  @media (max-width: 425px) {
    grid-column: 4 / span 1;
  }

  @media (max-width: 375px) {
    grid-column: 4 / span 1;
  }
`;

const drawerToggle = ({ pathname, clicked, isTop, show }) => {
  let menuColor = '#473880';
  if (
    (pathname === '/about-us' ||
      pathname === '/about-us/' ||
      pathname === '/') &&
    isTop
  ) {
    menuColor = '#FFFFFF';
  }

  let drive;

  if (pathname.startsWith('/drive')) {
    drive = true;
  } else {
    drive = false;
  }

  const handleClick = () => {
    clicked();
    document.dispatchEvent(new Event('sideBarOpened'));
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <DrawerWapper
      onClick={handleClick}
      data-testid="drawer"
      show={show}
      drive={drive}
    >
      <Menu fill={menuColor} height="24px" width="24px" />
    </DrawerWapper>
  );
};

drawerToggle.propTypes = {
  show: propTypes.bool,
  clicked: propTypes.func.isRequired,
  pathname: propTypes.string,
  isTop: propTypes.bool,
};

drawerToggle.defaultProps = {
  pathname: '',
  isTop: false,
  show: true,
};

export default drawerToggle;
